import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "wouter";
import "./index.css";
import "@fontsource/be-vietnam-pro/400.css";
import "@fontsource/be-vietnam-pro/600.css";
import {
  consumeObservedMarketingIdentityBoundary,
  getMarketingSessionId,
  subscribeMarketingIdentityBoundaries,
} from "@/lib/analytics/marketingSession";
import { clearPersistedAttributionAtAuthBoundary } from "@/lib/analytics/attributionCookies";
import { observeCurrentWebAnalyticsConsent } from "@/lib/analytics/marketingObservations";
import { reconcileConsentFromSharedCookie, subscribeConsent } from "@/lib/consent/cookiebar";
import { bootstrapCookiebar } from "@/lib/consent/loadCookiebar";
import { setupCookiebarScrollLock } from "@/lib/consent/cookiebarScrollLock";
import App from "./app/App";

getMarketingSessionId();
const bootstrapIdentityBoundary = consumeObservedMarketingIdentityBoundary();
if (bootstrapIdentityBoundary.journeyReplaced) clearPersistedAttributionAtAuthBoundary();

const unsubscribeMarketingIdentityBoundary = subscribeMarketingIdentityBoundaries(() => {
  clearPersistedAttributionAtAuthBoundary();
  reconcileConsentFromSharedCookie();
  observeCurrentWebAnalyticsConsent();
});

// Load cookie consent banner without inline scripts to satisfy CSP.
bootstrapCookiebar();
setupCookiebarScrollLock();

// Consent is independent. Subscribing immediately forwards an already-known decision and later
// CookieYes changes; backend jobs reconcile it by observation time.
const unsubscribeConsent = subscribeConsent(observeCurrentWebAnalyticsConsent);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    unsubscribeConsent();
    unsubscribeMarketingIdentityBoundary();
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element with id "root" was not found.');
}

const app = (
  <HelmetProvider>
    <Router>
      <App />
    </Router>
  </HelmetProvider>
);

if (rootElement.firstElementChild) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
